import request from "./request";
/**
 * 更改普通用户权限为管理员
 * @param otherId 用户id
 */
export default async function updateRoleAdmin(data) {
  return await request.post("/spin/sysUser/updateRoleAdmin", data);
}
